import React from 'react';
import { Link, graphql } from 'gatsby';

import Pagination from '../components/Pagination';
import Bio from '../components/Bio';
import Layout from '../components/Layout';
import SEO from '../components/seo';
import Footer from '../components/Footer';
import { rhythm, scale } from '../utils/typography';

import { formatReadingTime } from '../utils/helpers';

class BlogIndex extends React.Component {

  render() {
    const { data, pathContext } = this.props;
    const { group, index, first, last } = pathContext;
    console.log(pathContext)
    const prevUrl = index - 1 === 1 ? "/" : `/${index - 1}`;
    const nextUrl = `/${index + 1}`;
    const total = data.allMarkdownRemark.edges.length;
    const siteTitle = data.site.siteMetadata.title;
    const posts = data.allMarkdownRemark.edges;
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="All posts"
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        <Bio />

        {group.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug;
          return (
            <div key={node.fields.slug}>
              <h3
                style={{
                  marginBottom: rhythm(1 / 4),
                  fontSize: 22
                }}
              >
                <Link style={{ boxShadow: `none` }} to={node.fields.slug}>
                  {title}
                </Link>
              </h3>
              <p
                style={{
                  ...scale(-1 / 5),
                  display: `block`,
                  marginTop: rhythm(0),
                  marginBottom: rhythm(0.2),
                  color: 'var(--textNormal)'
                }}
              >
                {node.frontmatter.date}
                {` • ${formatReadingTime(node.fields.readingTime && node.fields.readingTime.minutes || 0)}`}
              </p>
              <p style={{ color: 'var(--textNormal)' }} dangerouslySetInnerHTML={{ __html: node.frontmatter.prologue || node.excerpt }} />
            </div>
          );
        })}
        <div className="pagination">
          <Pagination className="prev" tag={first} url={prevUrl} text="⬅" />
          <span className="pageNumber" style={{ color: 'var(--textNormal)' }}>
            {index} / {Math.ceil(total / 5)}
          </span>
          <Pagination className="next" tag={last} url={nextUrl} text="➡" />
        </div>
        <Footer />
      </Layout>
    );
  }
}

export default BlogIndex;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      totalCount
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MM DD, YYYY")
            title
          }
        }
      }
    }
  }
`;
